module.exports = __webpack_public_path__ + "static/media/medal.2dea2a6f.png";